<template>
<div class="whole-card" @mouseenter="hover=true" @mouseleave="hover=false" @click="$emit('toStudent',title,id)">
  <el-checkbox :checked="selected" class="check" v-if="hover"></el-checkbox>
  <i class="el-icon-close" v-if="hover"></i>
  <img src="http://data.xiyilab.com/web/main/static/首页/banner1.png" width="100%" >
  <div class="title">
    {{title}}
  </div>
  <div class="end-time" >
    最后提交时间：{{endTime}}
  </div>
  <div class="count">
    <div class="count-num">
      {{total}}/{{count}}
    </div>
    <el-progress :percentage="count/total*100" :show-text="false" class="line"></el-progress>
  </div>
</div>
</template>

<script>
const date=new Date()
export default {
  name: 'reviewCard',
  props:{
    id:{
      type:String,
    },
    selected:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:'123',
    },
    total:{
      type:Number,
      default: 40
    },
    count:{
      type:Number,
      default:12
    },
    pic:{
      type:String,
      default:'/首页/banner1.png'
    },
    endTime:{
      type:String,
      default:date.toString()
    }
  },
  data(){
    return{
      hover:false
    }
  }
}
</script>

<style scoped>
.whole-card{
  width: 10vw;
  height: 7vw;
  font-size: 0.6vw;
  margin: 0 0.5vw 0.5vw;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}
.whole-card i{
  position: absolute;
  top:0.2vw;
  right:0.2vw;
  font-size: 0.8vw;
  color:white;
}
.check{
  position: absolute;
  top:0.2vw;
  left: 0.3vw;
}
.whole-card:hover{
  transform: translate(0,-5px);
}
.whole-card img{
  height: 4vw;
}
.count{
  display: flex;
  flex-wrap: nowrap;
  color:#a0a0a0;
}
.line{
  width: 5vw;
  margin: auto;
}
.end-time{
  color:#a0a0a0;
}
</style>
